import * as THREE from "three";
import DtDecor from "./3d/decor.js";
import DtCamera from "./3d/camera.js";
import DtScene from "./3d/scene.js";
import DtLights from "./3d/lights.js";
import DtElement from "./3d/element.js";
import {DRACOLoader} from "three/addons/loaders/DRACOLoader";

export default class ThreeDMain {
    animationFrame = null;
    renderer = null;
    scene = null;
    camera = null;

    constructor() {
        this.animationFrame = null;

        document.getElementById("3d-loader").style.display = "flex";

        const configuration = JSON.parse(sessionStorage.getItem('3dConfiguration'));

        const canvas = document.getElementById('canvas-3d');

        this.scene = new DtScene();

        this.renderer = new THREE.WebGLRenderer({
            alpha: true,
            antialias: true
        });

        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(canvas.clientWidth, canvas.clientHeight);
        this.renderer.setClearColor("#CCC", 1);
        this.renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
        this.renderer.toneMapping = THREE.LinearToneMapping;
        this.renderer.shadowMap.enabled = true;
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;

        this.camera = new DtCamera(this.renderer, configuration.dimensions.width/2, configuration.dimensions.height/2, configuration.dimensions.width);
        const lights = new DtLights(configuration.dimensions.width, configuration.dimensions.height, configuration.dimensions.width);
        this.scene.add(lights);

        const decor = new DtDecor(configuration.dimensions.width, configuration.dimensions.height, configuration.dimensions.width);
        this.scene.add(decor);

        this.dracoLoader = new DRACOLoader();
        this.dracoLoader.setDecoderConfig({ type: 'js' });
        this.dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        configuration.elements.forEach((elementJson, index) => {
            let element = new DtElement(elementJson, configuration.dimensions, this.dracoLoader);
            window.sceneElements.push(element);
            this.scene.add(element);
        });

        canvas.appendChild( this.renderer.domElement );
        this.animate();

        checkSceneElementsLoaded();
    }

    animate() {
        this.animationFrame = requestAnimationFrame(x => this.animate(this.renderer, this.camera, this.scene) );
        if (this.camera.position.y < 100) {
            this.camera.position.y = 100;
        }
        if (this.camera.position.z < 100) {
            this.camera.position.z = 100;
        }
        this.renderer.render( this.scene, this.camera );
    }

    destroyScene()
    {
        cancelAnimationFrame(this.animationFrame);
        this.scene = null;
        this.renderer = null;
        this.camera = null;
        document.getElementById("lightSlider3d").value = 10;
    }
}

function checkSceneElementsLoaded() {
    if(window.sceneElements.filter((element) => !element.hasBeenLoaded).length > 0) {
        window.setTimeout(checkSceneElementsLoaded, 100);
    } else {
        window.setTimeout(() => document.getElementById("3d-loader").style.display = "none", 100);
    }
}
window.sceneElements = [];

window.ThreeDMain = ThreeDMain;